export const QUESTION_IMAGES = {
    SHORT: "short.svg",
    LONG: "long.svg",
    EMAIL: "email.svg",
    WEBSITE: "website.svg",
    MULTIPLE: "multiple.svg",
    DATE: "date.svg",
    FILE_UPLOAD: "file_upload.svg",
    NUMBER: "number.svg",
    PHONE: "phone.svg",
    CONTACT: "contact.svg",
    NPS: "nps.svg",
    SCORE: "score.svg",
    RATING: "rating.svg",
    SECTION: "section.svg",
    END: "end.svg",

    // CHECKBOX: "checkbox.svg",  
    // TIME: "time.svg",
}

export const DEBOUNCE_TIME = 500;

